module.exports = __webpack_public_path__ + "img/testimonial_6.e07e0b06.png";